import { FC } from 'react';
import { AllieText } from '../../../../components';

import {
  StyledAllieButton,
  StyledAllieEyeIcon,
  StyledButtonContent,
  StyledLoginIcon,
  StyledTextContainer,
} from './Spectator.styles';

interface SpectatorModeProps {
  onClick: () => void;
  labels: {
    message: string;
    login: string;
  };
  platform?: 'mobile' | 'desktop' | 'tablet';
}

const PLATFORMS = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

export const SpectatorMode: FC<SpectatorModeProps> = ({ onClick, labels, platform }) => {
  return (
    <StyledAllieButton
      isMobile={platform === PLATFORMS.MOBILE}
      allieSize="small"
      corner="rounded-edges-plus"
      onclick={onClick}
    >
      <StyledButtonContent isMobile={platform === PLATFORMS.MOBILE}>
        <StyledAllieEyeIcon color="white" />
        <StyledTextContainer>
          <AllieText
            type={platform === PLATFORMS.MOBILE ? 'body3' : 'body1'}
            color="white"
            weight={600}
          >
            <div style={{ lineHeight: platform === PLATFORMS.MOBILE ? '12px' : '16px' }}>
              {labels.message}
            </div>
          </AllieText>
          <AllieText
            type={platform === PLATFORMS.MOBILE ? 'field3' : 'button-small'}
            color={platform === PLATFORMS.MOBILE ? 'white' : 'neutral-20'}
            weight={platform === PLATFORMS.MOBILE ? 600 : 500}
          >
            {labels.login}
          </AllieText>
        </StyledTextContainer>
        {platform === PLATFORMS.DESKTOP && <StyledLoginIcon />}
      </StyledButtonContent>
    </StyledAllieButton>
  );
};
